import { Box, Button, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import { add, format } from "date-fns";
import { ja } from "date-fns/locale";
import { useSnackbar } from "notistack";
import React from "react";
import { getAdjustmentList } from "../../Api/Adjustment";
import { ApiError } from "../../Api/ApiError";
import { getReserveTypeCount } from "../../Api/Reserve";
import { AdjustmentAccounts } from "../../Objects/AdjustmentAccounts";
import { AdjustmentCancel } from "../../Objects/AdjustmentCancel";
import { AdjustmentCouponGet } from "../../Objects/AdjustmentCouponGet";
import { AdjustmentCouponUse } from "../../Objects/AdjustmentCouponUse";
import { AdjustmentDiscount } from "../../Objects/AdjustmentDiscount";
import { AdjustmentEquipment } from "../../Objects/AdjustmentEquipment";
import { AdjustmentStudio } from "../../Objects/AdjustmentStudio";
import { CancelData } from "../../Objects/CancelData";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import AdjustmentAccountsList from "../molecules/AdjustmentAccountsList";
import AdjustmentCancelList from "../molecules/AdjustmentCancelList";
import AdjustmentCouponGetList from "../molecules/AdjustmentCouponGetList";
import AdjustmentCouponUseList from "../molecules/AdjustmentCouponUseList";
import AdjustmentDiscountList from "../molecules/AdjustmentDiscountList";
import AdjustmentEquipmentList from "../molecules/AdjustmentEquipmentList";
import AdjustmentStudioList from "../molecules/AdjustmentStudioList";
import CancelList from "../molecules/CancelList";

const StoreAdjustmentDaily: React.FC = () => {
    let { enqueueSnackbar } = useSnackbar()
    let { storeObjectState } = React.useContext(StoreObjectStore)

    const [showDate, setShowDate] = React.useState<Date>(new Date())

    const [adjStudioList, setAdjStudioList] = React.useState<AdjustmentStudio[]>()
    const [adjEquipmentList, setAdjEquipmentList] = React.useState<AdjustmentEquipment[]>()
    const [adjCouponUseList, setAdjCouponUseList] = React.useState<AdjustmentCouponUse[]>()
    const [adjCouponGetList, setAdjCouponGetList] = React.useState<AdjustmentCouponGet[]>()
    const [adjDiscountList, setAdjDiscountList] = React.useState<AdjustmentDiscount[]>()
    const [adjAccountsList, setAdjAccountsList] = React.useState<AdjustmentAccounts[]>()
    const [adjCancelList, setAdjCancelList] = React.useState<AdjustmentCancel[]>()
    const [cancelList, setCancelList] = React.useState<CancelData[]>()

    const [reserveTypeStore, setReserveTypeStore] = React.useState<number>()
    const [reserveTypeStorePad, setReserveTypeStorePad] = React.useState<number>()
    const [reserveTypeMypagePC, setReserveTypeMypagePC] = React.useState<number>()
    const [reserveTypeMypageMobile, setReserveTypeMypageMobile] = React.useState<number>()
    const [reserveTypeOther, setReserveTypeOther] = React.useState<number>()

    React.useEffect(() => {
        const controller = new AbortController()
        if (storeObjectState.storeData?.str_id) {
            setAdjStudioList(undefined)
            setAdjEquipmentList(undefined)
            setAdjCouponUseList(undefined)
            setAdjCouponGetList(undefined)
            setAdjDiscountList(undefined)
            setAdjAccountsList(undefined)
            setAdjCancelList(undefined)
            setCancelList(undefined)
            getAdjustmentList({
                str_id: storeObjectState.storeData.str_id,
                date: showDate
            }, {signal: controller.signal}).then(result => {
                setAdjStudioList(result.adj_studio_list)
                setAdjEquipmentList(result.adj_equipment_list)
                setAdjCouponUseList(result.adj_coupon_use_list)
                setAdjCouponGetList(result.adj_coupon_get_list)
                setAdjDiscountList(result.adj_discount_list)
                setAdjAccountsList(result.adj_accounts_list)
                setAdjCancelList(result.adj_cancel_list)
                setCancelList(result.cancel_list)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

            setReserveTypeStore(undefined)
            getReserveTypeCount({
                str_id: storeObjectState.storeData.str_id,
                reserve_type: "STORE",
                date: showDate,
                count_range: "daily"
            }, {signal: controller.signal}).then(result => {
                setReserveTypeStore(result.count)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

            setReserveTypeStorePad(undefined)
            getReserveTypeCount({
                str_id: storeObjectState.storeData.str_id,
                reserve_type: "STORE_PAD",
                date: showDate,
                count_range: "daily"
            }, {signal: controller.signal}).then(result => {
                setReserveTypeStorePad(result.count)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

            setReserveTypeMypagePC(undefined)
            getReserveTypeCount({
                str_id: storeObjectState.storeData.str_id,
                reserve_type: "MYPAGE_PC",
                date: showDate,
                count_range: "daily"
            }, {signal: controller.signal}).then(result => {
                setReserveTypeMypagePC(result.count)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

            setReserveTypeMypageMobile(undefined)
            getReserveTypeCount({
                str_id: storeObjectState.storeData.str_id,
                reserve_type: "MYPAGE_MOBILE",
                date: showDate,
                count_range: "daily"
            }, {signal: controller.signal}).then(result => {
                setReserveTypeMypageMobile(result.count)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })

            setReserveTypeOther(undefined)
            getReserveTypeCount({
                str_id: storeObjectState.storeData.str_id,
                reserve_type: "OTHER",
                date: showDate,
                count_range: "daily"
            }, {signal: controller.signal}).then(result => {
                setReserveTypeOther(result.count)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
        return () => {
            controller.abort()
        }
    }, [showDate, storeObjectState.storeData?.str_id, enqueueSnackbar])

    return (
        <Box>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Button
                    variant="outlined"
                    onClick={() => {
                        setShowDate(date => add(date, { days: -1 }))
                    }}
                >前日</Button>
                <Stack
                    direction="row"
                    alignItems="center"
                >
                    <Typography>{format(showDate, "yyyy年M月d日 EEEE", { locale: ja })}</Typography>
                </Stack>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setShowDate(date => add(date, { days: 1 }))
                    }}
                >翌日</Button>
            </Stack>
            <Divider sx={{ mt: 1 }} />
            <Stack
                sx={{
                    width: "100%",
                    maxWidth: 600,
                    mx: "auto",
                    mt: 3,
                }}
                spacing={3}
            >
                <AdjustmentStudioList
                    adj_studio_list={adjStudioList}
                />
                <AdjustmentEquipmentList
                    adj_equipment_list={adjEquipmentList}
                />
                <AdjustmentCouponUseList
                    adj_coupon_use={adjCouponUseList}
                />
                <AdjustmentCouponGetList
                    adj_coupon_get={adjCouponGetList}
                />
                <AdjustmentDiscountList
                    adj_discount_list={adjDiscountList}
                />
                <AdjustmentAccountsList
                    adj_accounts_list={adjAccountsList}
                />
                <AdjustmentCancelList
                    adj_cancel_list={adjCancelList}
                />
                <CancelList
                    cancel_list={cancelList}
                />
                <Paper>
                    <Stack
                        spacing={1}
                        p={2}
                    >
                        <Typography fontWeight="bold" color="primary">予約受付件数</Typography>
                        <Divider />
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign={{
                                    xs: "left",
                                    sm: "right"
                                }} fontWeight="bold" color="primary">店頭受付</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign="right">{reserveTypeStore !== undefined ? reserveTypeStore : ""}件</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign={{
                                    xs: "left",
                                    sm: "right"
                                }} fontWeight="bold" color="primary">店頭予約端末受付</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign="right">{reserveTypeStorePad !== undefined ? reserveTypeStorePad : ""}件</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign={{
                                    xs: "left",
                                    sm: "right"
                                }} fontWeight="bold" color="primary">Web予約(PC)受付</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign="right">{reserveTypeMypagePC !== undefined ? reserveTypeMypagePC : ""}件</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign={{
                                    xs: "left",
                                    sm: "right"
                                }} fontWeight="bold" color="primary">Web予約(携帯)受付</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign="right">{reserveTypeMypageMobile !== undefined ? reserveTypeMypageMobile : ""}件</Typography>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign={{
                                    xs: "left",
                                    sm: "right"
                                }} fontWeight="bold" color="primary">その他受付(不明等)</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography textAlign="right">{reserveTypeOther !== undefined ? reserveTypeOther : ""}件</Typography>
                            </Grid>
                        </Grid>
                    </Stack>
                </Paper>
            </Stack>
        </Box>
    );
}

export default StoreAdjustmentDaily